import { useContext } from 'react';
import { ContainerContext } from '../containers/ContainerContext';

const useContainerProps = props => {
  return { ...useContext(ContainerContext), ...props };
}

export default useContainerProps;
